module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0109.jpg?v=34858f02";